import { render, staticRenderFns } from "./mpsFuncInfoManage.vue?vue&type=template&id=6953cf12&scoped=true&"
import script from "./mpsFuncInfoManage.vue?vue&type=script&lang=js&"
export * from "./mpsFuncInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./mpsFuncInfoManage.vue?vue&type=style&index=0&id=6953cf12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953cf12",
  null
  
)

component.options.__file = "mpsFuncInfoManage.vue"
export default component.exports